/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const OfficeMeasurement = createEnum('OFFICE_MEASUREMENT', {
  Imperial: 'IMPERIAL',
  Metric: 'METRIC',
});

export type OfficeMeasurement = EnumSet<typeof OfficeMeasurement>;
